import AddPaymentMethodsPage from '@fhs-legacy/frontend/src/components/add-payment-method-modal/add-payment-method-modal';
export { ErrorBoundary } from '@fhs/routing/src/components/page-dev-error-boundary';

export default AddPaymentMethodsPage;
